import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import toast from 'react-hot-toast';

import RowUser from "../components/RowUser";
import { userService } from '../container';


export default function Users() {
  const [searchParams] = useSearchParams();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);

  const loadUsers = async () => {
    const filters = {
      name: searchParams.get('name'),
      role: searchParams.get('role'),
    };

    setLoading(true);

    try {
      const users = await userService.search({
        ...filters,
      });

      setUsers(
        users
          .sort((a, b) => a.username.localeCompare(b.username))
      );
    } catch (err) {
      toast.error('Ocurrió un error al cargar los usuarios.');
      console.error(err);
    }

    setLoading(false);
  };

  const changeName = async (userId, { name, lastName }) => {
    setUpdating(true);

    try {
      await userService.update(userId, {
        name,
        last_name: lastName,
      });

      loadUsers();
    } catch (err) {
      toast.error('Ocurrió un error al actualizar el nombre del usuario.');
      console.error(err);
    }

    setUpdating(false);
  }

  const changeEmail = async (userId, email) => {
    setUpdating(true);

    try {
      await userService.changeEmail(userId, email);

      loadUsers();
    } catch (err) {
      toast.error('Ocurrió un error al actualizar el email del usuario.');
      console.error(err);
    }

    setUpdating(false);
  }

  const changeRole = async (userId, role) => {
    setUpdating(true);

    try {
      await userService.changeRole(userId, role);

      loadUsers();
    } catch (err) {
      toast.error('Ocurrió un error al actualizar el rol del usuario.');
      console.error(err);
    }

    setUpdating(false);
  }

  const changePassword = async (userId, password) => {
    setUpdating(true);

    try {
      await userService.changePassword(userId, password);

      loadUsers();
    } catch (err) {
      toast.error('Ocurrió un error al actualizar la contraseña del usuario.');
      console.error(err);
    }

    setUpdating(false);
  }

  const changeMedias = async (userId, mediaIds) => {
    setUpdating(true);

    try {
      await userService.changeMedias(userId, mediaIds);

      loadUsers();
    } catch (err) {
      toast.error('Ocurrió un error al actualizar los medios del usuario.');
      console.error(err);
    }

    setUpdating(false);
  }

  const deleteUser = async (userId) => {
    setUpdating(true);

    try {
      await userService.delete(userId);

      loadUsers();
    } catch (err) {
      toast.error('Ocurrió un error al eliminar el usuario.');
      console.error(err);
    }

    setUpdating(false);
  }

  useEffect(() => {
    loadUsers();
  }, [searchParams]);

  if (loading) {
    return <span>Loading...</span>;
  }

  return (
    <>
      <h1 className="t-heading-xl-cms">Usuarios</h1>

      <div id="content">
        <div className="table">
          <div className="head">
              <div className="row">
                <div className="col-3">
                  <p>Usuario</p>
                </div>

                <div className="col-5">
                  <p>Email</p>
                </div>

                <div className="col-2">
                  <p>Rol</p>
                </div>
              </div>
          </div>

          <div className="body">
            {users && users.map((user) => (
              <RowUser
                key={user.id}
                user={user}
                loading={updating}
                onChangeName={changeName}
                onChangeEmail={changeEmail}
                onChangeRole={changeRole}
                onChangePassword={changePassword}
                onChangeMedias={changeMedias}
                onDelete={deleteUser}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  )
}
